import { Injectable } from '@angular/core';
import { OverlayFile, PackClause, PacksFile,EvaluationResult,FormFile  } from '../models/sut-models';

function evalExpr(expr: string, scope: any): boolean {
if (!expr) return true;
// Very small DSL: allow identifiers, literals, comparisons, &&, ||, !, parentheses, startsWith/includes helpers
// We compile to Function with strict whitelist to avoid security issues.
const helpers = {
startsWith: (a: string, b: string) => (a ?? '').startsWith(b ?? ''),
includes: (arr: any[], v: any) => Array.isArray(arr) && arr.includes(v),
anyPrefix: (prefixes: string[], code?: string) => !!(code && prefixes?.some(p => code.startsWith(p))),
inList: (v: any, arr: any[]) => Array.isArray(arr) && arr.includes(v),
};
const fn = new Function('model', 'Claim', 'Documents', 'Report', 'Params', 'Lists', 'helpers',
`"use strict"; return ( ${expr} );`);
try {
return !!fn(scope.model, scope.Claim, scope.Documents, scope.Report, scope.Params, scope.Lists, helpers);
} catch {
return false;
}
}


@Injectable({ providedIn: 'root' })
export class RuleEngineService {
evaluatePackClause(node: PackClause, scope: any): boolean {
if (!node) return true;
if (node.type === 'CLAUSE') {
return evalExpr(node.cond || 'true', scope);
}
const children = node.children || [];
if (node.type === 'ALL') {
return children.every(c => this.evaluatePackClause(c, scope));
}
if (node.type === 'ANY') {
return children.some(c => this.evaluatePackClause(c, scope));
}
return true;
}


evaluatePacks(overlay: OverlayFile, packs: PacksFile, scope: any): { ok: boolean; failedPack?: string } {
for (const pid of overlay.use_packs) {
const p = packs.packs[pid];
if (!p) continue;
const pass = this.evaluatePackClause(p, scope);
if (!pass) return { ok: false, failedPack: pid };
}
return { ok: true };
}


evaluateForm(form: FormFile, scope: any): EvaluationResult {
// coveredIf is OR of expressions
const covered = form.evaluate.coveredIf.some(expr => evalExpr(expr, scope));
const reasons: string[] = [];
if (!covered) {
for (const r of form.evaluate.notCoveredReasons) {
if (evalExpr(r.when, scope)) reasons.push(r.reason);
}
if (!reasons.length) reasons.push('SUT koşulları sağlanmadı.');
}
return { covered, outcome: covered ? 'COVERED' : 'NOT_COVERED', reasons };
}
}